module.exports = __webpack_public_path__ + "img/solution9.b9ef5563.jpg";